import HourlyThird from "./HourlyThird";

export default HourlyThird;